import { useState } from 'react'
import { Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination'

import * as S from './styles'

import { slides } from 'constants/mocks'

import HavLogo from 'assets/svg/login/hav-logo.svg'

type AuthLayoutProps = {
  children?: React.ReactNode
}

export const AuthLayout = ({ children }: AuthLayoutProps) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [infoOpacity, setInfoOpacity] = useState(1)

  const handleTransparent = () => {
    if (slides.length > 1) setInfoOpacity(0)
  }

  return (
    <S.Wrapper>
      <S.SwiperPanel>
        <S.InfoContainer opacity={infoOpacity}>
          <S.InfoTitle>{slides[currentSlide].title}</S.InfoTitle>
          <S.InfoDescription>{slides[currentSlide].description}</S.InfoDescription>
        </S.InfoContainer>
        <Swiper
          slidesPerView={1}
          modules={[Pagination]}
          pagination={{ type: 'bullets', clickable: true }}
          onTouchMove={handleTransparent}
          onTouchEnd={() => setInfoOpacity(1)}
          onSlideChange={(swiper) => setCurrentSlide(swiper.realIndex)}
        >
          {slides.map((slide, index) => {
            return (
              <SwiperSlide key={`slide-${index}`}>
                <S.ImageGradient>
                  <S.SwiperImage src={slide.image} />
                </S.ImageGradient>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </S.SwiperPanel>
      <S.FormPanel>
        <S.Logo src={HavLogo} alt="Logomarca Havaianas" />
        {children}
      </S.FormPanel>
    </S.Wrapper>
  )
}
